<div>
  <div class="po-row po-mb-2">
    <po-button 
      [p-label]="isExpanded() ? 'Ver Cronograma Mensal' : 'Ver Cronograma Completo'" 
      (p-click)="toggleView()"
      [p-icon]="isExpanded() ? 'po-icon-minus' : 'po-icon-plus'"
      p-type="primary">
    </po-button>
  </div>

  <div class="timeline-container">
<!-- 
    <div class="legend-container animate-in">
      <div class="legend-item">
        <div class="color-bullet" [style.background-color]="'#9b51e0'"></div>
        <span>Performance</span>
      </div>
      <div class="legend-item">
        <div class="color-bullet" [style.background-color]="'#e91e63'"></div>
        <span>Matriz</span>
      </div>
      <div class="legend-item">
        <div class="color-bullet" [style.background-color]="'#0c2d3e'"></div>
        <span>Metas</span>
      </div>
    </div> -->

    @if (isExpanded()) {
      <div class="gantt-wrapper animate-in">
        <div class="gantt-grid">
          @for (mesNome of meses; track $index) {
            <div class="month-header" [style.grid-column]="$index + 1">
              {{ mesNome }}
            </div>
          }

          @for (grupo of atividadesAgrupadas; track $index) {
            <div class="task-merged" 
                 [ngClass]="grupo.cor + '-completed'"
                 [style.grid-column-start]="grupo.inicio"
                 [style.grid-column-end]="grupo.fim + 1">
              
              <ul class="task-list">
                @for (itemNome of grupo.itens; track itemNome) {
                  <li>{{ itemNome }}</li>
                }
              </ul>
            </div>
          }

        </div>
      </div>

    } @else {
      <div class="compact-view animate-in">
        <h2 class="po-mb-2 po-font-title">Atividades de {{ meses[mesAtual() - 1] }}</h2>
        
        @if (agendaHoje().length === 0) {
          <po-info p-label="Aviso" p-value="Nenhuma atividade para este mês."></po-info>
        } @else {
          <div class="compact-grid">
            @for (item of agendaHoje(); track item.nome) {
              <div class="compact-card" [ngClass]="item.cor">
                <div class="card-accent"></div>
                <div class="card-content">
                  <span class="category-label">{{ item.categoria }}</span>
                  <p class="task-title">{{ item.nome }}</p>
                  @if (item.firstMonth === item.lastMonth) {
                     <div class="duration-badge">
                        <span class="po-icon po-icon-calendar"></span>
                        {{ item.lastMonth }}
                    </div>
                  } @else {
                    <div class="duration-badge">
                        <span class="po-icon po-icon-calendar"></span>
                        {{ item.firstMonth }} até {{ item.lastMonth }}
                    </div>
                  }
                </div>
              </div>
            }
          </div>
        }
      </div>
    }
  </div>
</div>